/* eslint-disable padding-line-between-statements */
import React, { useCallback, useMemo, useEffect, useContext, useState } from 'react';
import _ from 'lodash';
import { appendMetadataWithIndex } from '@xengage/gw-jutro-adapters-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { Icon } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import metadata from './MarketAccessoryComponent.metadata.json5';
import messages from './MarketAccessoryComponent.messages';
import styles from './MarketAccessoryComponent.module.scss';

import { Button, InputField, InputNumberField } from '@jutro/legacy/components';
import classNames from 'classnames';
import { Link } from '@jutro/router';

function MarketAccessoryComponent(props) {

    const {
        id,
        value: marketAccessoriesVM,
        onValueChange,
        onValidate,
        index,
        path,
        handleAddMarketAccessory
    } = props;

    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);	
    const { isComponentValid, onValidate: setComponentValidation } = useValidation(id);


    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
        
    }, [id, isComponentValid, onValidate]);

    const handleValueChange = useCallback(
        (value, changedPath) => {
            if (onValueChange) {
                onValueChange(value, changedPath);
            }
        },
        [onValueChange]
    );

    const generateNewMarketAccessoryRow = useCallback(
        (event) => {
            event.preventDefault();
            if (marketAccessoriesVM.value === undefined) {
                marketAccessoriesVM.value = [];
            }
            const { _xCenter, _dtoName } = marketAccessoriesVM;
            const marketAccessoryRecordVM = viewModelService.create({},_xCenter, _dtoName);
            handleAddMarketAccessory(marketAccessoryRecordVM);
        },
        [marketAccessoriesVM, path, viewModelService, handleAddMarketAccessory ]
    );

    const getMarketAccessoryTableCell =  useCallback(
        (item, index, props) => {
           let path = props.path;
           const value = item[path];
            if (props.path == 'accessoryName') {
                path  = `afterMarketAccessories.children[${index}].${path}`;
                return (
                    <InputField
                        dataType="string"
                        id={index + path}
                        value={value}
                        path={path}
                        onValueChange={handleValueChange}
                    />
                );
            }
            else if (props.path == 'accessoryValue') {
                path  = `afterMarketAccessories.children[${index}].${path}`;
                return (
                    <InputNumberField
                        dataType="number"
                        id={index + path}
                        value={value}
                        path={path}
                        onValueChange={handleValueChange}
                    />
                );
            }
        },
        [ handleValueChange]
    );

    const removeMarketAccessoryRecordVM = useCallback(
        (rowIndex) => {
            marketAccessoriesVM.value.splice(rowIndex, 1);
            handleValueChange(marketAccessoriesVM.value, path);
        },
        [ path, handleValueChange]
    );

    const removeMarketAccessoryRow = useCallback(
        (item, index) => {
            return (
                <Link
                    onClick={() => removeMarketAccessoryRecordVM(index, item)}
                    className={classNames(styles.deleteSection, styles.deleteRow)}
                >
                    <Icon icon="mi-delete" className={styles.deleteIcon} />
                </Link>
            );
        },
        [removeMarketAccessoryRecordVM]
    );

    const getSumValue = useCallback(
        () => {
            var total = 0;
            if(marketAccessoriesVM && marketAccessoriesVM.value && marketAccessoriesVM.value.length > 0) {
                var accessoriesArray = marketAccessoriesVM.value
                return accessoriesArray.map(item => item.accessoryValue ? parseInt(item.accessoryValue) : 0 ).reduce((prev, curr) => prev + curr, 0);
            }
            return total;
        },
        [marketAccessoriesVM]
    );



    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = useMemo(() => ({
        "@field": {
            showRequired: true,
            showOptional: false,
            labelPosition: 'left',
        },
        [`marketAccessoryTableSection${index}`]:{
            visible : marketAccessoriesVM && marketAccessoriesVM.value && marketAccessoriesVM.value.length > 0
        },
        [`marketAccessoryTable${index}`]:{
            data :  marketAccessoriesVM ? marketAccessoriesVM.value : []
        }, 
        [`totalSumValue${index}`]:{
            value :  getSumValue(marketAccessoriesVM)
        }, 

    }),[marketAccessoriesVM]);

    const resolvers = {
        resolveCallbackMap: {
            generateNewMarketAccessoryTableRow: generateNewMarketAccessoryRow,
            removeMarketAccessoryTableRow: removeMarketAccessoryRow,
            getMarketAccessoryTableCell
        }
    };

    const formattedMetadata = useMemo(() => appendMetadataWithIndex(metadata.pageContent, index), [index]);

    return (
        <ViewModelForm
            uiProps={formattedMetadata}
            model={marketAccessoriesVM}
            overrideProps={overrideProps}
            onValidationChange={setComponentValidation}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={styles}
        />
    );

}

export default MarketAccessoryComponent;